// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_lk-0";